/**
 * Retrieves image blob from clipboard.  Assumes at most one image as copying multiple images is unlikely (usually
 * requires special clipboard tools)
 * @param {object} pasteEvent
 */
export const retrieveImageFromClipboard = pasteEvent => {
  if (!pasteEvent?.clipboardData) return null

  const items = pasteEvent.clipboardData.items
  if (!(Symbol.iterator in Object(items))) return null // iterable?

  let blob = null

  for (const item of items) {
    if (item.type?.startsWith('image')) {
      blob = item.getAsFile()
      break
    }
  }
  return blob
}

export const getImageURLFromBlob = imageBlob => {
  const URLObj = window.URL || window.webkitURL // Cross-browser support for URL
  return !imageBlob ? '' : URLObj.createObjectURL(imageBlob)
}
